import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Globalize from '@sprinx/globalize';
import { withStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import Typography from '@material-ui/core/Typography'; //

import extractCurrencyCode from '../utils/extractCurrencyCode';

function CurrencySymbol(_ref) {
  var classes = _ref.classes,
      component = _ref.component,
      currency = _ref.currency,
      noWrap = _ref.noWrap,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["classes", "component", "currency", "noWrap", "variant"]);

  var c = extractCurrencyCode(typeof currency === 'string' ? currency : currency.code);
  var settings = Globalize.locale().main("numbers/currencies/".concat(c));
  var currencySymbol = variant === 'accounting' ? settings['symbol-alt-narrow'] || settings.symbol : settings.symbol;
  return noWrap ? currencySymbol : /*#__PURE__*/React.createElement(Typography, _extends({}, pickHTMLProps(rest), {
    className: classes.root,
    component: component,
    variant: "inherit"
  }), currencySymbol);
}

CurrencySymbol.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  component: PropTypes.elementType,

  /**
   * Kod meny, ve ktere je hodnota. Pokud neni definovana, pouzije se nastaveni z MuiFieldsProvider.
   */
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    code: PropTypes.string.isRequired
  })]).isRequired,
  noWrap: PropTypes.bool,
  variant: PropTypes.oneOf(['accounting', 'code', 'symbol'])
};
CurrencySymbol.defaultProps = {
  component: 'span',
  noWrap: false,
  variant: 'accounting'
};
export default withStyles(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(0.5)
    }
  };
}, {
  name: 'SxCurrencySymbol'
})(CurrencySymbol);